import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { DelimitedTextSink } from 'app/model/pipeline/copysink/delimitedtext.sink';
import {
    convertStoreSettingsToResource,
    convertStoreSettingsToModel
} from '../copysource/store-read-settings/store-read-settings.util';
import {
    convertFormatSettingsToResource,
    convertFormatSettingsToModel
} from '../copysource/format-read-settings/format-read-settings.util';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DelimitedTextSink),
    asynchronous: true,
    adapts: {
        type: '*',
        copyBehavior: '*',
        quoteAll: '*',
        structure: '*',
        storeSettings: '*',
        formatSettings: '*'
    }
})
export class DelimitedTextSinkAdapter extends CopySinkAdapter<DelimitedTextSink, Model.DelimitedTextSink> {
    protected override async _toResource(model: DelimitedTextSink): Promise<Model.DelimitedTextSink> {
        const result: Model.DelimitedTextSink = {
            type: 'DelimitedTextSink'
        };

        await convertStoreSettingsToResource(model.storeSettings, result, this.context);
        await convertFormatSettingsToResource(model.formatSettings, result, this.context);
        return result;
    }

    protected override async _toModel(resource: Model.DelimitedTextSink, owner: Activity): Promise<DelimitedTextSink> {
        const result = Owned.create<DelimitedTextSink>(Metamodel.modelFor(DelimitedTextSink), owner);

        await convertStoreSettingsToModel(resource.storeSettings, result, this.context);
        await convertFormatSettingsToModel(resource.formatSettings, result, this.context);
        return result;
    }
}
